export default __webpack_public_path__ + "static/media/approved 1.92deca65.svg";